import axios, { Method, AxiosResponse, ResponseType } from 'axios';
import store from '@app/store';

import apiLinks from './api-links';
import { getCookie } from './cookie';
import { CookiesName } from './constants';

interface Options {
  url: ((al: typeof apiLinks) => string) | string;
  data?: object | string;
  params?: object;
  signal?: AbortSignal;
  contentType?: string;
  responseType?: ResponseType;
  // onUploadProgress: () => void;
}

interface FullOptions extends Options {
  method: Method;
}

const request = <T, R = AxiosResponse<T>>(arg: FullOptions): Promise<R> => {
  const {
    method,
    contentType = 'application/json',
    url,
    data,
    params,
    signal,
    responseType = 'json',
  } = arg;

  const source = axios.CancelToken.source();
  if (signal) {
    signal.addEventListener('abort', () => {
      source.cancel();
    });
  }

  const { token } = store.getState().auth;
  const cookie = getCookie(CookiesName.NAME);

  return axios.request<T, R>({
    method,
    headers: {
      'content-type': contentType,
      // Authorization: `bearer ${token?.access_token ?? cookie}`,
      Authorization: `bearer ${cookie}`,
    },
    url: typeof url === 'string' ? url : url(apiLinks),
    data,
    params,
    responseType,
    cancelToken: source.token,
  });
};

const httpClient = {
  request,
  get: <T, R = AxiosResponse<T>>(arg: Options): Promise<R> => {
    return request({ ...arg, method: 'GET' });
  },
  post: <T, R = AxiosResponse<T>>(arg: Options): Promise<R> => {
    return request({ ...arg, method: 'POST' });
  },
  put: <T, R = AxiosResponse<T>>(arg: Options): Promise<R> => {
    return request({ ...arg, method: 'PUT' });
  },
  delete: <T, R = AxiosResponse<T>>(arg: Options): Promise<R> => {
    return request({ ...arg, method: 'DELETE' });
  },
};

export default httpClient;
